import { broadcastDocumentationVersionError } from 'serviceWorker/services/httpQueue/errorHandlers/documentationVersion';
import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';

export function broadcastDocumentationVersionResponse(
  request: HttpRequestEntity,
  response: any
): void {
  if (response.error) {
    return broadcastDocumentationVersionError(request, response.error);
  }
  return;
}
